export default "__VITE_ASSET__Bkttdl5L__"